import { render } from "./AddTrainee.vue?vue&type=template&id=4701fea2&scoped=true"
import script from "./AddTrainee.vue?vue&type=script&lang=js"
export * from "./AddTrainee.vue?vue&type=script&lang=js"

import "./AddTrainee.vue?vue&type=style&index=0&id=4701fea2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4701fea2"]])

export default __exports__